export const ServiceRequestActivityTypes = {  
    email: "email",
    notes: "notes",
    requestDetails: "details"
}